import React from "react";
import classNames from "classnames";
import { TransactionRuleGroup } from "../../../../common/types/transactionRule";
import styles from "../RulesTable.module.scss";
import { pluralize } from "../../../../common/helpers/string";
import { EmptyState } from "./EmptyState";
import { GroupHeaderCell } from "./GroupHeaderCell";

interface GroupOverlayProps {
    group: TransactionRuleGroup;
}

export const GroupOverlay: React.FC<GroupOverlayProps> = ({ group }) => (
    <table>
        <tbody>
            {!group.rules?.length ? (
                <tr className={styles.ruleOverlayRow}>
                    <EmptyState group={group} />
                </tr>
            ) : (
                <tr key={group.id} className={styles.ruleOverlayRow}>
                    <GroupHeaderCell group={group} rowSpan={1} />
                    <td
                        colSpan={2}
                        className={classNames("pl-2", styles.rulesCount)}
                    >
                        {group.rules?.length}{" "}
                        {pluralize("rule", group.rules.length)}
                    </td>
                </tr>
            )}
        </tbody>
    </table>
);
